import { render, staticRenderFns } from "./csNewDL.vue?vue&type=template&id=f192daf2&scoped=true&"
import script from "./csNewDL.vue?vue&type=script&lang=js&"
export * from "./csNewDL.vue?vue&type=script&lang=js&"
import style0 from "./csNewDL.vue?vue&type=style&index=0&id=f192daf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f192daf2",
  null
  
)

export default component.exports